// extracted by mini-css-extract-plugin
export default {"l_checkbax_container_main":"CheckbaxContainer_l_checkbax_container_main__yyDU0"};